export default __webpack_public_path__ + "static/media/Database_Storage.118fdb72.png";